import { getPlannerMapData } from '../../../HttpRequests/planner'
import { setMapData, startMapLoading, finishMapLoading, setMapError } from '../State/mapData'
import handleException from '../../../Core/Helpers/handleException'

export default (options = {}) => async (dispatch, getState) => {
  const { controls, additionalFilter } = getState().screens.Planner
  const { silent } = options

  if (!silent) {
    dispatch(startMapLoading())
  }

  try {
    var params = {
      period_index: controls.periodIndex,
      day_of_week: controls.dayOfWeek,
      search: controls.projectSearch || undefined,
      db_contracts_manager: controls.contractsManagerId.join() || undefined,
      db_status_key: controls.statusKey.join() || undefined,
      db_phase_key: controls.phaseKey.join() || undefined,
      db_omitted: controls.omitted ? 1 : 0,
    }

    // Add project_id filter from additionalFilter (for componentView mode)
    if (additionalFilter && additionalFilter.project_id) {
      params.db_project_id = additionalFilter.project_id
    }

    const response = await getPlannerMapData({ params })

    dispatch(setMapData(response.data))
  } catch (error) {
    const errorMessage = (error && error.response && error.response.data && error.response.data.message) || 'Failed to load map data'
    dispatch(setMapError(errorMessage))
    handleException(error)
  } finally {
    if (!silent) {
      dispatch(finishMapLoading())
    }
  }
}
